import { ChargeType } from './charge-type';

/**
 * This class encapsulates static values for the charge types in CFM.
 * The structure of this class allows for the chrage types to be used like an enum by using the ChargeTypes.[x] syntax.
 */
export class ChargeTypes {

	public static readonly Shipment: ChargeType = new ChargeType("SHP", 0, "Shipment");

	public static readonly Pickup: ChargeType = new ChargeType("PU", 1, "Pickup");

	public static readonly Delivery: ChargeType = new ChargeType("DEL", 2, "Delivery");

	public static readonly Transfer: ChargeType = new ChargeType("XFER", 3, "Transfer");

	public static readonly LineHaul: ChargeType = new ChargeType("LH", 4, "Line Haul");

	public static readonly LineHaulSegment: ChargeType = new ChargeType("LHSEG", 5, "Line Haul Segment");

	public static readonly Stop: ChargeType = new ChargeType("STP", 6, "Stop");

	public static readonly Surcharge: ChargeType = new ChargeType("SUR", 7, "Surcharge");

	public static readonly DoorToDoor: ChargeType = new ChargeType("D2D", 8, "Door to Door");
	
}